import React, { Component, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import { postData, getData, patchData, deleteData } from "../../util/Fetch";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import swal from "sweetalert";
import EditIcon from "@mui/icons-material/Edit";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import CustomerSelectModal from "./CustomerSelectModal";
import SearchIcon from "@mui/icons-material/Search";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const ReserveModal = (props) => {
  const [serviceList, setServiceList] = React.useState([]);
  const [customerSelectModalProps, setCustomerSelectModalProps] = useState({
    onClose: () => {},
    open: false,
    list: [],
    title: "",
  });

  const [reserve, setReserve] = React.useState({
    ServiceId: 0,
    StaffId: 0,
    Note: "",
    ReserveTime: "",
    CustomerId: 0,
    CustomerName: "",
    CustomerPhone: "",
    ServiceName: "",
  });

  const [serviceNameEditable, setServiceNameEditable] = useState(false);

  useEffect(() => {
    GetServiceList();

    setCustomerSelectModalProps({
      onClose: CustomerSelectModelOnClose,
      open: false,
      list: [],
      title: "請選擇用戶",
    });
  }, []);

  useEffect(() => {
    if (props.reserve) {
      setReserve({
        Id: props.reserve.eventId,
        ServiceId: props.reserve.serviceId,
        StaffId: props.reserve.staffId,
        Note: props.reserve.note,
        CustomerName: props.reserve.customerName,
        CustomerPhone: props.reserve.customerPhone,
      });
      setServiceNameEditable(props.reserve.serviceName ? true : false);
    } else {
      setReserve({
        Id: 0,
        ServiceId: 0,
        StaffId: 0,
        Note: "",
        ReserveTime: "",
        ReserveTimeFrom: props.reserveTimeFrom,
        ReserveTimeTo: props.reserveTimeTo,
      });
    }
  }, [props]);

  const SearchCustomers = () => {
    var keyword = "";
    var phone = "";

    if (reserve.CustomerName) {
      keyword = keyword + reserve.CustomerName;
    }
    if (reserve.CustomerPhone) {
      phone = phone + reserve.CustomerPhone;
    }

    if (!keyword && !phone) {
      return;
    }

    getData("Consumer", {
      keyword: keyword,
      phone: phone,
    }).then((res) => {
      if (res.length === 0) {
        swal("查無用戶");
        return;
      }

      setCustomerSelectModalProps({
        onClose: CustomerSelectModelOnClose,
        open: true,
        list: res,
        title: "請選擇用戶",
      });
    });
  };

  const GetServiceList = () => {
    getData("SalonService", { id: 0 }).then((res) => {
      setServiceList(res);
    });
  };

  const CustomerSelectModelOnClose = (item) => {
    console.log(item);
    if (item && (item.name || item.phone || item.cellphone))
      setReserve({
        ...reserve,
        CustomerId: parseInt(item.id ?? 0),
        CustomerName: item.name,
        CustomerPhone: item.cellphone ?? item.phone ?? "",
      });

    setCustomerSelectModalProps({
      ...customerSelectModalProps,
      open: false,
    });
  };

  const resetReserve = () => {
    setReserve({
      ServiceId: 0,
      StaffId: 0,
      Note: "",
      ReserveTime: "",
      ServiceName: "",
    });
  };

  const handleChange = (e) => {
    setReserve({ ...reserve, [e.currentTarget.id]: e.currentTarget.value });
  };

  const handleSelectStylistChange = (e) => {
    setReserve({ ...reserve, StaffId: e.target.value });
  };

  const handleSelectServiceChange = (e) => {
    setReserve({ ...reserve, ServiceId: e.target.value });
  };

  const handleSubmit = () => {
    if (props.reserve) {
      patchData("Calander", { ...reserve, type: "reserve" }).then((res) => {
        if (res === true) {
          swal("修改成功", "資料已新增置資料庫", "success");
          props.GetEvents();
        } else {
          swal("新增失敗", "系統出現不知名錯誤，請聯絡管理員", "error");
        }
      });
    } else {
      postData("Calander", reserve).then((res) => {
        if (res != null) {
          swal("新增成功", "資料已新增置資料庫", "success");
          props.GetEvents();
        } else {
          swal("新增失敗", "系統出現不知名錯誤，請聯絡管理員", "error");
        }
      });
    }
    resetReserve();
    props.closeModel();
  };

  useEffect(() => {
    if (serviceNameEditable === false) {
      setReserve({ ...reserve, ServiceName: "" });
    }
  }, [serviceNameEditable]);

  const handleEditable = () => {
    setServiceNameEditable(!serviceNameEditable);
  };

  return (
    <div>
      <CustomerSelectModal
        onClose={customerSelectModalProps.onClose}
        open={customerSelectModalProps.open}
        list={customerSelectModalProps.list}
        title={customerSelectModalProps.title}
      ></CustomerSelectModal>
      <Modal
        open={props.open}
        onClose={props.closeModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {serviceNameEditable === true && (
            <Stack sx={{ width: "100%" }} direction={"row"}>
              <FormControl variant="standard" sx={{ m: 1, width: "90%" }}>
                <TextField
                  id="ServiceName"
                  onChange={handleChange}
                  value={reserve.serviceName}
                  label="服務項目"
                ></TextField>
              </FormControl>
              <FormatListNumberedIcon
                disabled={props.reserve ? true : false}
                onClick={handleEditable}
                sx={{ width: "10%", mt: 2.5 }}
              />
            </Stack>
          )}
          {serviceNameEditable === false && (
            <Stack direction={"row"} sx={{ width: "100%" }}>
              <FormControl
                variant="standard"
                sx={{ m: 1, width: props.reserve ? "100%" : "90%" }}
              >
                <InputLabel id="ServiceId">服務項目</InputLabel>
                <Select
                  id="ServiceId"
                  value={reserve.ServiceId}
                  label="服務項目"
                  onChange={handleSelectServiceChange}
                  disabled={props.reserve ? true : false}
                >
                  <MenuItem key={0} value={0}>
                    {"休假"}
                  </MenuItem>

                  {serviceList.map((x) => (
                    <MenuItem key={x.serviceId} value={x.serviceId}>
                      {x.serviceName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {!props.reserve && (
                <EditIcon
                  onClick={handleEditable}
                  sx={{ width: "10%", mt: 2.5 }}
                />
              )}
            </Stack>
          )}

          <Stack spacing={2} sx={{ width: "100%" }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <InputLabel id="StaffId">員工選單</InputLabel>
              <Select
                id="StaffId"
                value={reserve.StaffId}
                label="預約員工"
                onChange={handleSelectStylistChange}
                disabled={props.reserve ? true : false}
              >
                {props.stylists.map((x) => (
                  <MenuItem key={x.staffId} value={x.staffId}>
                    {x.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack
            spacing={2}
            sx={{ width: "100%", marginTop: "2%" }}
            direction="row"
          >
            <Stack sx={{ width: "90%" }}>
              <TextField
                id="CustomerName"
                value={reserve.CustomerName}
                label="客戶姓名"
                onChange={handleChange}
                variant="outlined"
              />
            </Stack>
            <Stack sx={{ width: "10%", alignSelf: "center" }}>
              <SearchIcon onClick={SearchCustomers}></SearchIcon>
            </Stack>
          </Stack>
          <Stack spacing={2} sx={{ width: "100%", marginTop: "2%" }}>
            <TextField
              id="CustomerPhone"
              value={reserve.CustomerPhone}
              label="客戶電話"
              onChange={handleChange}
              variant="outlined"
            />
          </Stack>
          <Stack spacing={2} sx={{ width: "100%", marginTop: "2%" }}>
            <TextField
              id="Note"
              label="備註"
              value={reserve.Note}
              onChange={handleChange}
              variant="outlined"
            />
          </Stack>
          <Stack spacing={2} sx={{ width: "100%", marginTop: "2%" }}>
            <Button variant="contained" onClick={handleSubmit}>
              {props.reserve ? "修改" : "新增"}
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default ReserveModal;
